import { render } from "./LeadAreaList.vue?vue&type=template&id=76e9f5ed"
import script from "./LeadAreaList.vue?vue&type=script&lang=js"
export * from "./LeadAreaList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__